import { useEffect, useState } from 'react';
import { useI18n } from '../../lib/i18n';
import { Badge, Card, Loading, PageHeader } from '../../ui/components';

/** A page anyone may open to see whether the software is working. */
export function StatusPage() {
  const i18n = useI18n();
  const [data, setData] = useState<any | null>(null);

  useEffect(() => {
    const load = (): void => {
      fetch('/v1/public/status').then((r) => r.json()).then(setData).catch(() => setData({ status: 'degraded', components: [] }));
    };
    load();
    const timer = setInterval(load, 60_000);
    return () => clearInterval(timer);
  }, []);

  if (!data) return <Loading />;
  return (
    <div className="public">
      <main className="public-main narrow">
        <PageHeader title={i18n.t('status.title')} subtitle={i18n.t(data.status === 'ok' ? 'status.ok' : 'status.degraded')} />
        <Card>
          {(data.components ?? []).map((c: any) => (
            <div key={c.key} className="row between">
              <span>{i18n.t(`status.${c.key}`)}</span>
              <Badge value={c.status === 'ok' ? 'good' : 'bad'} label={i18n.t(c.status === 'ok' ? 'status.state_ok' : 'status.state_problem')} />
            </div>
          ))}
          {data.checkedAt && <p className="small muted">{i18n.t('status.checked', { time: i18n.time(data.checkedAt) })}</p>}
        </Card>
      </main>
    </div>
  );
}
